import axiosInstance from '../../axios-config';

const userProfileApi = 'api/patientportaluser/loginprofile';
const setUserPrefApi = '/api/users/{0}/Preferences';
const resendEmailConfirmationEmailApi = 'api/users/{0}/sendConfirmEmail?language={1}';
const updateUserUrl = 'api/users/{userId}/replace';

export const getUser = () =>
  axiosInstance.get(userProfileApi);

export const setUserPreference = (userId, value, filterName) =>
  axiosInstance.put(setUserPrefApi.replace('{0}', userId), {
    userId,
    name: filterName,
    value,
  }, {
    headers: { 'Content-Type': 'application/json' },
  })
    .then((response) => response.data);

export const resendConfirmationEmail = (userId, language) =>
  axiosInstance.post(resendEmailConfirmationEmailApi
    .replace('{0}', userId)
    .replace('{1}', language));

export const acceptTermsOfUse = (userId) => (
  axiosInstance.patch(updateUserUrl.replace('{userId}', userId),
    [
      {
        op: 'replace',
        path: '/isEulaAccepted',
        value: 'true',
      },
    ],
    {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    }
  )
);

export const saveProvidedEmail = (userId, email) => (
  axiosInstance.patch(updateUserUrl.replace('{userId}', userId),
    [
      {
        op: 'replace',
        path: '/email',
        value: email,
      },
    ],
    {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    }
  )
);
